/**
 * LOGISPRD-12506 — 로그인 경로 문자열의 단일 출처.
 *
 * `AuthUtils.logout()` 은 로그아웃 후 리다이렉트할 기본 경로로 `PATHS['auth.login']` 값 하나만
 * 필요했는데, 기존에는 `@/utils/routes/paths` 를 통째로 import 해서 얻었다. `paths.tsx` 는
 * `ROUTES_WITH_ELEMENTS`(어드민 페이지 53개 모듈의 실제 컴포넌트 트리)를 런타임에 `Object.entries` 로
 * 순회해 `PATHS` 맵을 만들기 때문에, 그 import 하나만으로 어드민 페이지 모듈 그래프 전체가 정적으로
 * 딸려온다. 온콜 콘솔은 `AuthUtils`(→ 로그아웃 아이콘)를 쓰는 `MainHeader` 를 셸에 붙이면서 이 경로로
 * 어드민 그래프 전체(ag-grid-enterprise 포함)를 끌고 와 번들이 16배로 불었다(gzip 133.88 kB → 2,085.64 kB).
 *
 * 이 모듈은 그 경로 문자열만 떼어 어떤 무거운 모듈도 import 하지 않는다. `paths.tsx` 도 이 상수를
 * `'auth.login'` 키의 값으로 그대로 쓴다 — `/auth/login` 이 두 곳에서 따로 하드코딩되지 않고 한 곳에서만
 * 정의된다.
 */
export const AUTH_LOGIN_PATH = '/auth/login'
